<template>
  <ChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
  />
</template>

<script>
import { Doughnut as ChartGenerator } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  name: "doughnutChart",
  components: {
    ChartGenerator,
  },
  props: {

    chartData: {
      type: Object,
      //required: true,
      default: () => {
        return {
          labels: ['Label1', 'Label2'],
          datasets: [
            {
              backgroundColor: ['#41B883', '#E46651'],
              data: [40, 20]
            }
          ]
        }
      }
    },

    chartOptions: {
      type: Object,
      default: () => {
        return {

        }
      }
    },

    chartId: {
      type: String,
      default: 'doughnut-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 300
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
}
</script>
